import { Box, Button } from '@mui/material';
import React, { useContext, useState } from 'react'
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

const steps = [
    {
        target: '.first-step',
        title: 'Library',
        content: 'You will find these your create publication',
        placement: 'right',
        disableBeacon: true,
        disableScrollParentFix: true,
        disableScrolling: true,
    },
    {
        target: '.second-step',
        title: 'Approver',
        content: 'You will find the For Review authors publication',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.third-step',
        title: 'Report',
        content: 'You can see your publication performance here',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.fourth-step',
        title: 'Indquiries',
        content: 'You can see the all inquiry for you publication',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.fifth-step',
        title: 'Help',
        content: 'Resources that guide users through personalizing their experience, following step-by-step instructions, and finding quick answers.',
        placement: 'top',
        disableBeacon: true,
    },
    {
        target: '.sixth-step',
        title: 'Support',
        content: 'Access customer assistance for troubleshooting and guidance to make the most out of the product.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.seventh-step',
        title: 'Get App',
        content: 'Download the app for easy access.',
        placement: 'top',
        disableBeacon: true,
    },
    {
        target: '.eighth-step',
        title: 'Bible',
        content: 'Read God word anytime anywhere',
        placement: 'right',
        disableBeacon: true,
    },
     {
        target: '.ninth-step',
        title: 'Notification',
        content: 'Check your latest notifications here.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.tenth-step',
        title: 'My Tools',
        content: 'Quick-access shortcuts to all available tools to help you use key features faster.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.eleventh-step',
        title: 'Profile',
        content: 'Manage your settings, preferences, and personal details while exploring additional features.',
        placement: 'left',
        disableBeacon: true,
    },
    
];

export const General = () => {
    const { tool_state, personalization_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { walkthrough } = personalization_state

    const [stepIndex, setStepIndex] = useState(0);

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
    const tool_id =  process.env.REACT_APP_TID_BIZ;
    const role_name = __SESSION.data.uaccess[0].role_name

    const checkRole = (index, role_name) => {
        if (index === 1 && role_name !== 'Approver' && role_name !== 'Super Admin') {
            return true;
        }
        return false;
    }

    const handleJoyrideCallback = async (data) => {
        const { status, action, index, type } = data;
        
        let body = {
            user_id: user_id,
            tool_id: tool_id,
            feature_name: 'general',
            personalization: [{ sf_name: "general", status: 1 }]
        }

        if (type === 'step:after' && action === 'next') {
            let nextStep = index + 1;

            if (checkRole(nextStep, role_name)) {
                nextStep++;
            }

            setStepIndex(nextStep);
        }
        
        if (['close', 'stop'].includes(action)) {
            walkthrough.set(prev => ({...prev, general: false}))
            setStepIndex(0);
            await rqx.post(`<<global>>/${env()}/personalization/create`, body)
        }
    };	
    
    return (
        <Joyride
            run={walkthrough.data.general}
            continuous
            disableOverlayClose={true}
            steps={steps}
            stepIndex={stepIndex}
            showSkipButton={true}
            callback={handleJoyrideCallback}
            tooltipComponent={CustomComponent}
        />
    )
}

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
	return (
		<Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
			<Box fontSize="14px" fontWeight="600">{step.title}</Box>
			<Box fontSize="12px" py="4px">{step.content}</Box>

			<Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
                <Button {...closeProps} variant={index === 10 ? 'contained' : 'Skip'} disableElevation sx={{ fontSize: '12px', p: '4px 16px' }}>
                    {index === 10 ? 'Got it!' : 'Skip'}
                </Button>
                {
                    index !== 10 &&
                    <Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
                        Next
                    </Button>
                }
			</Box>
		</Box>
	);
};
